import 'core-js/es6/map';



// WEBPACK FOOTER //
// ./src/lib/polyfills.js